module.exports = __webpack_public_path__ + "static/media/BitOrigin.6dcfbc0d.png";